import { render, staticRenderFns } from "./PageRoute.vue?vue&type=template&id=c3e2b480&"
import script from "./PageRoute.vue?vue&type=script&lang=js&"
export * from "./PageRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3e2b480')) {
      api.createRecord('c3e2b480', component.options)
    } else {
      api.reload('c3e2b480', component.options)
    }
    module.hot.accept("./PageRoute.vue?vue&type=template&id=c3e2b480&", function () {
      api.rerender('c3e2b480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/route/PageRoute.vue"
export default component.exports